import React from 'react'
import { Check as CheckIcon, Clear as ClearIcon } from '@material-ui/icons'
import * as S from './style'

interface Props {
  touched?: boolean
  valid: boolean
  children: React.ReactNode
}

const Requirement = ({ touched = false, valid, children }: Props): JSX.Element => {
  return (
    <S.Container touched={touched} valid={valid}>
      {touched && (valid ? <CheckIcon /> : <ClearIcon />)}
      {children}
    </S.Container>
  )
}

export default Requirement
